import { Typography } from '@apostrophe/ui';
import Cart from 'components/payment/Cart';
import { createOrderLineItems } from 'helpers/paymentHelpers';
import {
	filter,
	find,
	groupBy,
	orderBy,
} from 'lodash';
import React, {
	useEffect, useState
} from 'react';
import {
	animated,Transition
} from 'react-spring';

import {
	OrderSummary,
} from '../../../apps/orderConfirmation/src/styles';
import SingleOption from './Cards/SingleOption';
import CheckoutKit from './CheckoutKit';
import OutOfCart from './OutOfCart';
import {
	Barrier,
	BetterTogether,
	ProductWrapper,
	SaveTenWrapper,
} from './styles';

const ProductSelection = ({
	products,
	cart,
	changeOption,
	removeProduct,
	setAutoShip,
	handleModalOpen,
	patientID,
	consultationID,
	clientToken,
	modalHasBeenOpened,
	lastOrder,
	otcProducts,
	addProduct,
	setOTCProduct,
	setOTCModalOpen,
	otcTypeInCart,
	otcCheckout,
	currentRXKit,
	isRXKit,
	setKitModalOpen,
	setRXKit,
	bundlePrice,
	bundleDiscountPrice,
	invoices,
}) => {
	let allProductsInCart = true;
	let inCartindex = 0;

	const productsByType = groupBy(products,
		'treatment_type');
	const [lineItems, setLineItems] = useState([]);
	const [isTablet, setIsTablet] = useState(false);
	const [noPurchasableProducts, setNoPurchasableProducts] = useState(true);

	// Handle RX Products
	orderBy(Object.keys(productsByType),
		[],
		['desc']).map(key => {
		const sortedProducts = orderBy(productsByType[key],
			['disabled', 'autoRefill'],
			['asc', 'desc']);
		sortedProducts.map(product => {
			// Check if this product is purchasable
			if (product.options.length !== 0) {
				if (noPurchasableProducts) {
					setNoPurchasableProducts(false);
				}
			}
			// Check if this product is in the cart
			if (!cart.products[product.id] && product.quantity_remaining > 0) {
				if (product.options.length !== 0) {
					allProductsInCart = false;
				}
			}
		})
	});

	useEffect(() => {
		if (lastOrder) {
			const lineItems = createOrderLineItems(lastOrder);
			setLineItems(lineItems);
		}
		if (window) {
			setIsTablet(!window.matchMedia('(max-width: 768px)').matches);
		}
	},
	[]);

	useEffect(() => {
		if (otcProducts && otcTypeInCart) {
			otcProducts.forEach((product) => {
				if (product.otc_type === otcTypeInCart) {
					if (!cart.products[product.id]) {
						addProduct(product.id,
							product.options[0]);
					}
					if (noPurchasableProducts) {
						setNoPurchasableProducts(false);
					}
				}
			});
		}
	},
	[]);

	return (
		<ProductWrapper currentRXKit={currentRXKit} className="section" data-cy={'ProductWrapper'} role="main" id="main-content">
			<Typography variant="h1" className="checkout-header">{!noPurchasableProducts ? 'Review Order' : 'No products available'}</Typography>
			<hr/>
			{noPurchasableProducts && lastOrder &&
        <>
        	<p>Your last order:</p>
        	<OrderSummary>
        		<Cart
        			lineItems={lineItems}
        			crossSell
        			state={{}}
        		/>
        	</OrderSummary>
        	<p>If you think this is a mistake, please contact care@apostrophe.com, or navigate to your <a href="/yd/patient/dashboard/">dashboard</a> and message the care team.</p>
        </>
			}
			{Object.keys(cart.products).length === 0 && <h3>Your cart is currently empty!</h3>}
			{allProductsInCart && Object.keys(productsByType).length > 1 && !RXKit &&
        <BetterTogether data-cy={'BetterTogether'}>
        	<div>
        		<SaveTenWrapper data-cy={'SaveTenWrapper'}>
        			<Typography variant="subtitle2">Better Together</Typography>
        		</SaveTenWrapper>
        		<p>When used together, these treatments are more effective in keeping breakouts under control.</p>
        	</div>
        </BetterTogether>
			}
			{currentRXKit &&
        <CheckoutKit
        	products={orderBy(productsByType.SKIN,
        		['disabled', 'autoRefill'],
        		['asc', 'desc'])}
        	setKitModalOpen={setKitModalOpen}
        	removeProduct={removeProduct}
        	cart={cart}
        	setRXKit={setRXKit}
        	bundlePrice={bundlePrice}
        	bundleDiscountPrice={bundleDiscountPrice}
        	patientId={patientID}
        	consultationId={consultationID}
        	clientToken={clientToken}
        />
			}
			{!currentRXKit && <div>
				{orderBy(Object.keys(productsByType),
					[],
					['desc']).map(key => {
					const sortedProducts = orderBy(productsByType[key],
						['disabled', 'autoRefill'],
						['asc', 'desc']);
					return (
						<div key={key} className="first-child-target">
							{sortedProducts.map((product, index) => {

								if (cart.products[product.id] && product.options.length !== 0) {
									inCartindex += 1;
								}
								const invoice = filter(invoices,
									({
										items, on_hold_date,
									}) => find(items,
										({ rx_type }) => rx_type == product.rx_type && on_hold_date ));

								return <Transition
									key={index}
									items={cart.products[product.id] && product.options.length !== 0}
									from={{
										opacity: 0,
										height: 0,
									}}
									enter={{
										opacity: 1,
										height: otcCheckout ? (isTablet ? 175 : 120) : 'max-content',
									}}
									leave={{
										opacity: 0,
										height: 0,
									}}
								>
									{(styles, item) => item && <animated.div key={item} style={styles}>
										<SingleOption
											key={product.id}
											changeOption={changeOption}
											removeProduct={removeProduct}
											setAutoShip={setAutoShip}
											product={product}
											cart={cart}
											index={inCartindex-1}
											otcCheckout={otcCheckout}
											invoice={invoice}
										/>
									</animated.div>}
								</Transition>
							})}
						</div>
					)
				})}
			</div>}
			{!allProductsInCart && (!isRXKit || (isRXKit && !currentRXKit)) &&
        <>
        	<Barrier isRXKit={isRXKit} />
        	<OutOfCart
        		removedProducts={products}
        		addProduct={addProduct}
        		removeProduct={removeProduct}
        		cart={cart}
        		invoices={invoices}
        	/>
        </>
			}
		</ProductWrapper>
	);
};

export default ProductSelection;
